import { Button, Form, Select, Text } from 'tea-component';
import React, { useEffect, useState } from 'react';
import relatedLinkIcon from '@/pages/intelligence/assets/imgs/jumpIcon.png';
import './index.scss';
import { getGameType, getUrlJump } from './_config';
import { useIntl } from 'umi';

function LinkSelector(props) {
  const { gameIdx, gameList } = props;
  const { formatMessage } = useIntl();
  const LEFT_JSON = {
    overview: formatMessage({ id: 'dbi_trendinggames_left_1' }),
    rank: formatMessage({ id: 'dbi_trendinggames_left_2' }),
    metrics: formatMessage({ id: 'dbi_trendinggames_left_3' }),
  };
  const OPTION_LEFT_LIST = [
    { value: 'overview', text: LEFT_JSON.overview }, // overview
    { value: 'rank', text: LEFT_JSON.rank }, // storeRank
    { value: 'metrics', text: LEFT_JSON.metrics }, // stats
  ];
  const RIGHT_JSON = {
    performance: formatMessage({ id: 'dbi_trendinggames_right_1' }),
    socialMedia: formatMessage({ id: 'dbi_trendinggames_right_2' }),
    gameStore: formatMessage({ id: 'dbi_trendinggames_right_3' }),
    newMedia: formatMessage({ id: 'dbi_trendinggames_right_4' }),
  };
  const OPTION_RIGHT_LIST = [
    { value: 'performance', text: RIGHT_JSON.performance }, // opinion/overview/performance
    { value: 'socialMedia', text: RIGHT_JSON.socialMedia }, // opinion/feeds/socialMedia
    { value: 'gameStore', text: RIGHT_JSON.gameStore }, // opinion/feeds/gameStore
    { value: 'newMedia', text: RIGHT_JSON.newMedia }, // opinion/feeds/newMedia
  ];
  const [link1, setLink1] = useState('overview');
  const [link2, setLink2] = useState('performance');

  const c = 0;

  const handleUrlJump = (value) => {
    const type = getGameType(gameIdx, gameList);
    // console.log("-------------------",value, gameIdx, type)
    const url = getUrlJump(value, gameIdx, type);
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <Form layout="inline" className="dbi-trending-selector-form">
      <Form.Item
        label={
          <>
            <img src={relatedLinkIcon} />
            <Text theme="label">{formatMessage({ id: 'dbi_trendinggames_related_links' })}</Text>
          </>
        }
      >
        <Select
          appearance="link"
          options={OPTION_LEFT_LIST}
          value={link1}
          onChange={(value) => {
            setLink1(value);
            handleUrlJump(value);
          }}
          matchButtonWidth={false}
          listWidth={150}
          button={
            <Button type="link" onClick={() => handleUrlJump(link1)} className="dbi-trending-LSbtn">
              {LEFT_JSON[link1]}
            </Button>
          }
        />
        <Select
          appearance="link"
          options={OPTION_RIGHT_LIST}
          value={link2}
          onChange={(value) => {
            setLink2(value);
            handleUrlJump(value);
          }}
          matchButtonWidth={false}
          listWidth={180}
          button={
            <Button type="link" onClick={() => handleUrlJump(link2)} className="dbi-trending-LSbtn">
              {RIGHT_JSON[link2]}
            </Button>
          }
        />
      </Form.Item>
    </Form>
  );
}

export default LinkSelector;
